module.exports = __webpack_public_path__ + "static/media/home.98750e5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ActivityBadge/icons/home.svg
// module id = 295
// module chunks = 0